define('controllers/signup/Podio.Controllers.Signup.New',['require','jquery','lib/backbone/Backbone.PodioController','lib/Podio.Event.UI'],function(require) {

  var $ = require('jquery');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var eventUI = require('lib/Podio.Event.UI');

  return PodioController.extend({
    initialize: function(options) {
      this._super();
      this.submitHiddenActivationForm();
      eventUI.bind('submit', 'form.signup-setup', this.onActivateUserFormSubmitted, true);
    },

    submitHiddenActivationForm: function() {
      // Auto submit on the activating page with the load spinner
      var elmForm = $('#activating_user_form');
      if (elmForm.length) {
        elmForm.submit();
      }
    },

    onActivateUserFormSubmitted: function(elmTarget, e) {
      // Show spinner overlay when user activation form is submitted
      var elmOverlay = $('.activating-overlay');
      elmOverlay.addClass('state-visible');
    }
  });
});

